import EditPaymentFrequency from "./EditPaymentFrequency";

export default EditPaymentFrequency;
